import { numerify } from '@/filters'
export default {
  components: {
  },
  computed: {
    billContractParams () {
      const ret = {}
      switch (this.dateMode) {
        case 'month':
          ret['time_range2.start_day'] = this.$moment().startOf('month').subtract(1, 'month').format('YYYYMMDD')
          ret['time_range2.end_day'] = this.$moment().subtract(1, 'day').subtract(1, 'month').format('YYYYMMDD')
          break
        case 'last_month':
          ret['time_range2.start_day'] = this.$moment().startOf('month').subtract(2, 'month').format('YYYYMMDD')
          ret['time_range2.end_day'] = this.$moment().subtract(2, 'month').endOf('month').format('YYYYMMDD')
          break
        case 'quarter':
          ret['time_range2.start_day'] = this.$moment().startOf('quarter').subtract(1, 'quarter').format('YYYYMMDD')
          ret['time_range2.end_day'] = this.$moment().subtract(1, 'day').subtract(1, 'quarter').format('YYYYMMDD')
          break
        case 'last_quarter':
          ret['time_range2.start_day'] = this.$moment().startOf('quarter').subtract(2, 'quarter').format('YYYYMMDD')
          ret['time_range2.end_day'] = this.$moment().subtract(2, 'quarter').endOf('quarter').format('YYYYMMDD')
          break
        case 'year':
          ret['time_range2.start_day'] = this.$moment().startOf('year').subtract(1, 'year').format('YYYYMMDD')
          ret['time_range2.end_day'] = this.$moment().subtract(1, 'day').subtract(1, 'year').format('YYYYMMDD')
          break
        default:
          break
      }
      return ret
    },
    billContractColumns () {
      let ret = [{
        field: 'amount2',
        slots: {
          default: ({ row }) => {
            const { amount = 0, amount2 = 0 } = row
            if (!amount && !amount2) return '-'
            if (!amount2) return [<span style="color: #F5222d">↑ ∞（{this.$t('bill.same_period_zero')}）</span>]
            if (!amount) return [<span style="color: #F5222d">↓ 100%</span>]
            const d = (amount - amount2) / Math.abs(amount2)
            let color = '#606266'
            switch (true) {
              case Math.abs(d) > 0.6:
                color = '#F5222d'
                break
              case Math.abs(d) > 0.2:
                color = '#faad14'
                break
              default:
                color = '#9c9c9c'
            }
            if (d === 0) {
              return [<span style={`color: ${color}`}>{this.$t('bill.no_change') }</span>]
            } else if (d > 0) {
              if (Math.abs(d) < 0.00001) {
                return [<span style={`color: ${color}`}>↑ &lt;0.01%</span>]
              }
              if (Math.abs(d) > 10000) {
                return [<span style={`color: ${color}`}>↑ ∞</span>]
              }
              return [<span style={`color: ${color}`}>↑ {numerify(Math.abs(d), '0.00%')}</span>]
            } else {
              if (Math.abs(d) < 0.00001) {
                return [<span style={`color: ${color}`}>↓ &lt;0.01%</span>]
              }
              return [<span style={`color: ${color}`}>↓ {numerify(Math.abs(d), '0.00%')}</span>]
            }
          },
        },
        formatter: ({ row }) => {
          const { amount = 0, amount2 = 0 } = row
          if (!amount && !amount2) return '-'
          if (!amount2) return `↑ ∞${this.$t('bill.same_period_zero')}`
          if (!amount) return '↓ 100%'
          const d = (amount - amount2) / Math.abs(amount2)
          if (d === 0) {
            return this.$t('bill.no_change')
          } else if (d > 0) {
            if (Math.abs(d) < 0.00001) {
              return '↑ <0.01%'
            }
            if (Math.abs(d) > 10000) {
              return '↑ ∞'
            }
            return `↑ ${numerify(Math.abs(d), '0.00%')}`
          } else {
            if (Math.abs(d) < 0.00001) {
              return '↓ <0.01%'
            }
            return `↓ ${numerify(Math.abs(d), '0.00%')}`
          }
        },
      }]
      switch (this.dateMode) {
        case 'month':
          ret[0].title = this.$t('bill.contract_last_month_period')
          break
        case 'last_month':
          ret[0].title = this.$t('bill.contract_before_last_month')
          break
        case 'quarter':
          ret[0].title = this.$t('bill.contract_last_quarter_period')
          break
        case 'last_quarter':
          ret[0].title = this.$t('bill.contract_before_last_quarter')
          break
        case 'year':
          ret[0].title = this.$t('bill.contract_last_year_period')
          break
        default:
          ret = []
          break
      }
      return ret
    },
  },
}
